import AbstractValidator from './AbstractValidator';
import DateValidator from './DateValidator';
import Time from './Time';

export default class DateTime extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notDateTime: 'Der eingebenene Zeitpunkt (%value%) ist nicht im richtigen Format.',
    };

    run()
    {
        let parts = this.value.split(' ');

        if(2 !== parts.length)
        {
            this.error = this.getMessage('notDateTime');

            return;
        }

        const DateV = new DateValidator(parts[0], {});
        DateV.run();

        if(DateV.error)
        {
            this.error = DateV.error;

            return;
        }

        const TimeValidator = new Time(parts[1], {});
        TimeValidator.run();

        if(TimeValidator.error)
        {
            this.error = TimeValidator.error;

            return;
        }

        if (new Date(this.value).toString() === 'Invalid Date')
        {
            this.error = this.getMessage('notDateTime');
        }
    }
}